var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('os'),
    EOL = _require.EOL;

var errors = require('../errors');

var _require2 = require('./runtime_support'),
    keyObjectSupported = _require2.keyObjectSupported;

var _require3 = require('./key_object'),
    createPublicKey = _require3.createPublicKey;

var base64url = require('./base64url');

var asn1 = require('./asn1');

var computePrimes = require('./rsa_primes');

var _require4 = require('../registry'),
    OKP_CURVES = _require4.OKP_CURVES,
    EC_CURVES = _require4.EC_CURVES;

var formatPem = function formatPem(base64pem, descriptor) {
  return "-----BEGIN ".concat(descriptor, " KEY-----").concat(EOL).concat((base64pem.match(/.{1,64}/g) || []).join(EOL)).concat(EOL, "-----END ").concat(descriptor, " KEY-----");
};

var okpToJWK = {
  private: function _private(crv, keyObject) {
    var der = keyObject.export({
      type: 'pkcs8',
      format: 'der'
    });
    var OneAsymmetricKey = asn1.get('OneAsymmetricKey');

    var _OneAsymmetricKey$dec = OneAsymmetricKey.decode(der),
        d = _OneAsymmetricKey$dec.privateKey.privateKey;

    return _objectSpread({}, okpToJWK.public(crv, createPublicKey(keyObject)), {
      d: base64url.encodeBuffer(d)
    });
  },
  public: function _public(crv, keyObject) {
    var der = keyObject.export({
      type: 'spki',
      format: 'der'
    });
    var PublicKeyInfo = asn1.get('PublicKeyInfo');

    var _PublicKeyInfo$decode = PublicKeyInfo.decode(der),
        x = _PublicKeyInfo$decode.publicKey.data;

    return {
      kty: 'OKP',
      crv: crv,
      x: base64url.encodeBuffer(x)
    };
  }
};
var keyObjectToJWK = {
  rsa: {
    private: function _private(keyObject) {
      var der = keyObject.export({
        type: 'pkcs8',
        format: 'der'
      });
      var PrivateKeyInfo = asn1.get('PrivateKeyInfo');
      var RSAPrivateKey = asn1.get('RSAPrivateKey');

      var _PrivateKeyInfo$decod = PrivateKeyInfo.decode(der),
          privateKey = _PrivateKeyInfo$decod.privateKey;

      var _RSAPrivateKey$decode = RSAPrivateKey.decode(privateKey),
          version = _RSAPrivateKey$decode.version,
          n = _RSAPrivateKey$decode.n,
          e = _RSAPrivateKey$decode.e,
          d = _RSAPrivateKey$decode.d,
          p = _RSAPrivateKey$decode.p,
          q = _RSAPrivateKey$decode.q,
          dp = _RSAPrivateKey$decode.dp,
          dq = _RSAPrivateKey$decode.dq,
          qi = _RSAPrivateKey$decode.qi;

      if (version !== 'two-prime') {
        throw new errors.JOSENotSupported('Private RSA keys with more than two primes are not supported');
      }

      return {
        kty: 'RSA',
        n: base64url.encodeBigInt(n),
        e: base64url.encodeBigInt(e),
        d: base64url.encodeBigInt(d),
        p: base64url.encodeBigInt(p),
        q: base64url.encodeBigInt(q),
        dp: base64url.encodeBigInt(dp),
        dq: base64url.encodeBigInt(dq),
        qi: base64url.encodeBigInt(qi)
      };
    },
    public: function _public(keyObject) {
      var der = keyObject.export({
        type: 'spki',
        format: 'der'
      });
      var PublicKeyInfo = asn1.get('PublicKeyInfo');
      var RSAPublicKey = asn1.get('RSAPublicKey');

      var _PublicKeyInfo$decode2 = PublicKeyInfo.decode(der),
          publicKey = _PublicKeyInfo$decode2.publicKey.data;

      var _RSAPublicKey$decode = RSAPublicKey.decode(publicKey),
          n = _RSAPublicKey$decode.n,
          e = _RSAPublicKey$decode.e;

      return {
        kty: 'RSA',
        n: base64url.encodeBigInt(n),
        e: base64url.encodeBigInt(e)
      };
    }
  },
  ec: {
    private: function _private(keyObject) {
      var der = keyObject.export({
        type: 'pkcs8',
        format: 'der'
      });
      var PrivateKeyInfo = asn1.get('PrivateKeyInfo');
      var ECPrivateKey = asn1.get('ECPrivateKey');

      var _PrivateKeyInfo$decod2 = PrivateKeyInfo.decode(der),
          privateKey = _PrivateKeyInfo$decod2.privateKey,
          crv = _PrivateKeyInfo$decod2.algorithm.parameters.value;

      var _ECPrivateKey$decode = ECPrivateKey.decode(privateKey),
          d = _ECPrivateKey$decode.privateKey,
          publicKey = _ECPrivateKey$decode.publicKey;

      if (typeof publicKey === 'undefined') {
        if (keyObjectSupported) {
          return _objectSpread({}, keyObjectToJWK.ec.public(createPublicKey(keyObject)), {
            d: base64url.encodeBuffer(d)
          });
        }

        throw new errors.JOSENotSupported('Private EC keys without the public key embedded are not supported in your Node.js runtime version');
      }

      var x = publicKey.data.slice(1, (publicKey.data.length - 1) / 2 + 1);
      var y = publicKey.data.slice((publicKey.data.length - 1) / 2 + 1);
      return {
        kty: 'EC',
        crv: crv,
        d: base64url.encodeBuffer(d),
        x: base64url.encodeBuffer(x),
        y: base64url.encodeBuffer(y)
      };
    },
    public: function _public(keyObject) {
      var der = keyObject.export({
        type: 'spki',
        format: 'der'
      });
      var PublicKeyInfo = asn1.get('PublicKeyInfo');

      var _PublicKeyInfo$decode3 = PublicKeyInfo.decode(der),
          publicKey = _PublicKeyInfo$decode3.publicKey.data,
          crv = _PublicKeyInfo$decode3.algorithm.parameters.value;

      var x = publicKey.slice(1, (publicKey.length - 1) / 2 + 1);
      var y = publicKey.slice((publicKey.length - 1) / 2 + 1);
      return {
        kty: 'EC',
        crv: crv,
        x: base64url.encodeBuffer(x),
        y: base64url.encodeBuffer(y)
      };
    }
  },
  ed25519: {
    private: function _private(keyObject) {
      return okpToJWK.private('Ed25519', keyObject);
    },
    public: function _public(keyObject) {
      return okpToJWK.public('Ed25519', keyObject);
    }
  },
  ed448: {
    private: function _private(keyObject) {
      return okpToJWK.private('Ed448', keyObject);
    },
    public: function _public(keyObject) {
      return okpToJWK.public('Ed448', keyObject);
    }
  },
  x25519: {
    private: function _private(keyObject) {
      return okpToJWK.private('X25519', keyObject);
    },
    public: function _public(keyObject) {
      return okpToJWK.public('X25519', keyObject);
    }
  },
  x448: {
    private: function _private(keyObject) {
      return okpToJWK.private('X448', keyObject);
    },
    public: function _public(keyObject) {
      return okpToJWK.public('X448', keyObject);
    }
  }
};

module.exports.keyObjectToJWK = function (keyObject) {
  if (keyObject.type === 'private') {
    return keyObjectToJWK[keyObject.asymmetricKeyType].private(keyObject);
  }

  return keyObjectToJWK[keyObject.asymmetricKeyType].public(keyObject);
};

var concatEcPublicKey = function concatEcPublicKey(x, y) {
  return {
    unused: 0,
    data: Buffer.concat([Buffer.alloc(1, 4), base64url.decodeToBuffer(x), base64url.decodeToBuffer(y)])
  };
};

var jwkToPem = {
  RSA: {
    private: function _private(jwk, _ref) {
      var calculateMissingRSAPrimes = _ref.calculateMissingRSAPrimes;
      var RSAPrivateKey = asn1.get('RSAPrivateKey');

      if ('oth' in jwk) {
        throw new errors.JOSENotSupported('Private RSA keys with more than two primes are not supported');
      }

      if (jwk.p || jwk.q || jwk.dp || jwk.dq || jwk.qi) {
        if (!(jwk.p && jwk.q && jwk.dp && jwk.dq && jwk.qi)) {
          throw new errors.JWKInvalid('all other private key parameters must be present when any one of them is present');
        }
      } else if (calculateMissingRSAPrimes) {
        jwk = computePrimes(jwk);
      } else if (!calculateMissingRSAPrimes) {
        throw new errors.JOSENotSupported('importing private RSA keys without all other private key parameters is not enabled, see documentation and its advisory on how and when its ok to enable it');
      }

      return RSAPrivateKey.encode({
        version: 0,
        n: BigInt("0x".concat(base64url.decodeToBuffer(jwk.n).toString('hex'))),
        e: BigInt("0x".concat(base64url.decodeToBuffer(jwk.e).toString('hex'))),
        d: BigInt("0x".concat(base64url.decodeToBuffer(jwk.d).toString('hex'))),
        p: BigInt("0x".concat(base64url.decodeToBuffer(jwk.p).toString('hex'))),
        q: BigInt("0x".concat(base64url.decodeToBuffer(jwk.q).toString('hex'))),
        dp: BigInt("0x".concat(base64url.decodeToBuffer(jwk.dp).toString('hex'))),
        dq: BigInt("0x".concat(base64url.decodeToBuffer(jwk.dq).toString('hex'))),
        qi: BigInt("0x".concat(base64url.decodeToBuffer(jwk.qi).toString('hex')))
      }, 'pem', {
        label: 'RSA PRIVATE KEY'
      });
    },
    public: function _public(jwk) {
      var RSAPublicKey = asn1.get('RSAPublicKey');
      return RSAPublicKey.encode({
        version: 0,
        n: BigInt("0x".concat(base64url.decodeToBuffer(jwk.n).toString('hex'))),
        e: BigInt("0x".concat(base64url.decodeToBuffer(jwk.e).toString('hex')))
      }, 'pem', {
        label: 'RSA PUBLIC KEY'
      });
    }
  },
  EC: {
    private: function _private(jwk) {
      var ECPrivateKey = asn1.get('ECPrivateKey');
      return ECPrivateKey.encode({
        version: 1,
        privateKey: base64url.decodeToBuffer(jwk.d),
        parameters: {
          type: 'namedCurve',
          value: jwk.crv
        },
        publicKey: concatEcPublicKey(jwk.x, jwk.y)
      }, 'pem', {
        label: 'EC PRIVATE KEY'
      });
    },
    public: function _public(jwk) {
      var PublicKeyInfo = asn1.get('PublicKeyInfo');
      return PublicKeyInfo.encode({
        algorithm: {
          algorithm: 'ecPublicKey',
          parameters: {
            type: 'namedCurve',
            value: jwk.crv
          }
        },
        publicKey: concatEcPublicKey(jwk.x, jwk.y)
      }, 'pem', {
        label: 'PUBLIC KEY'
      });
    }
  },
  OKP: {
    private: function _private(jwk) {
      var OneAsymmetricKey = asn1.get('OneAsymmetricKey');
      var b64 = OneAsymmetricKey.encode({
        version: 0,
        privateKey: {
          privateKey: base64url.decodeToBuffer(jwk.d)
        },
        algorithm: {
          algorithm: jwk.crv
        }
      }, 'der'); // TODO: WHYYY? https://github.com/indutny/asn1.js/issues/110

      b64.write('04', 12, 1, 'hex');
      return formatPem(b64.toString('base64'), 'PRIVATE');
    },
    public: function _public(jwk) {
      var PublicKeyInfo = asn1.get('PublicKeyInfo');
      return PublicKeyInfo.encode({
        algorithm: {
          algorithm: jwk.crv
        },
        publicKey: {
          unused: 0,
          data: base64url.decodeToBuffer(jwk.x)
        }
      }, 'pem', {
        label: 'PUBLIC KEY'
      });
    }
  }
};

module.exports.jwkToPem = function (jwk) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$calculateMissin = _ref2.calculateMissingRSAPrimes,
      calculateMissingRSAPrimes = _ref2$calculateMissin === void 0 ? false : _ref2$calculateMissin;

  switch (jwk.kty) {
    case 'EC':
      if (!EC_CURVES.has(jwk.crv)) {
        throw new errors.JOSENotSupported("unsupported EC key curve: ".concat(jwk.crv));
      }

      break;

    case 'OKP':
      if (!OKP_CURVES.has(jwk.crv)) {
        throw new errors.JOSENotSupported("unsupported OKP key curve: ".concat(jwk.crv));
      }

      break;

    case 'RSA':
      break;

    default:
      throw new errors.JOSENotSupported("unsupported key type: ".concat(jwk.kty));
  }

  if (jwk.d) {
    return jwkToPem[jwk.kty].private(jwk, {
      calculateMissingRSAPrimes: calculateMissingRSAPrimes
    });
  }

  return jwkToPem[jwk.kty].public(jwk);
};